import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";

export const STATUS_MARKERS = {
  ok: "✓\u2009",
  warn: "▲\u2009",
  crit: "■\u2009",
  info: "●\u2009",
  neutral: "–\u2009",
};

export const STATUS_PILL_BASE_SX = {
  display: "inline-flex",
  alignItems: "center",
  fontFamily: appThemeFonts.family.ui,
  fontSize: "12px",
  fontWeight: 500,
  padding: "3px 10px",
  borderRadius: appThemeRadius.pill,
  whiteSpace: "nowrap",
  lineHeight: 1.35,
};

export const getStatusToneStyles = (tone) => {
  const palette = appThemeColors.status[tone] || appThemeColors.status.neutral;
  return {
    color: palette.color,
    backgroundColor: palette.background,
  };
};
